<!--
 * @Autor: 
 * @Description: banner
 * @Date: 2021-07-12 18:22:27
 * @LastEditors: 郑展羽（zhengzy1@yunjiglobal.com）
 * @LastEditTime: 2021-07-22 15:13:05
-->
<template>
  <div class="top-moudle" v-if="bannerData.length > 0">
    <div 
      class="swiper-container new-banner" 
      :class="{'normal-banner': !fromNewGood, 'new-good-banner': fromNewGood }"
      ref="bannerBlock" 
      id="new-banner"
    >
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in bannerData" v-cloak :key="index" >
          <template v-if="item.imageUrl">
            <div class="banner-pic-wrapper" >
              <img class="new-more-banner-img" :src="item.imageUrl" alt="banner图片">
            </div>
          </template>
        </div>
    </div>
    <div class="swiper-pagination" v-show="bannerData.length > 1"></div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import { createNamespacedHelpers } from 'vuex'
import * as service from '@/pages/commodity/api/category-new'
import YunJi from '@/assets/js/YunJi.js'
import { createTrackObj, jumpHandle, createTrackContentIdList } from '../util'

const { mapState, mapMutations } = createNamespacedHelpers('categoryNav')
const isWxProgram = YunJi.isWxProgram()
const isApp = YunJi.isApp()

export default {
  name: 'banner',
  data() {
    return {
      shopId: YunJi.getUrlParams('shopId'),
      appCont: YunJi.getUrlParams('appCont') || 0,
      bannerData: [],
      bottomLineType: 0,
      newBannerSwiper: null
    }
  },
  watch: {
    'categoryId'() {
      this.moduleLeave() // 离开曝光埋点
      this.queryPageModuleTabResourceImg()
    }
  },
  computed: {
    ...mapState(['categoryId', 'newGoodsTabId', 'parentLevelName']),
    fromNewGood() {
      return this.newGoodsTabId === this.categoryId
    }
  },
  mounted() {
    this.queryPageModuleTabResourceImg()
  },
  beforeDestroy() {
    this.moduleLeave() // 离开曝光埋点
    if (this.newBannerSwiper && this.newBannerSwiper.destroy) {
      this.newBannerSwiper.destroy()
    }
  },
  methods: {
    ...mapMutations(['SETBANNERREQ']),
    queryPageModuleTabResourceImg() {
      const params = {
        appCont: this.appCont,
        dataType: 1, // 1-banner 2-蛋坑
        tabId: this.categoryId,
        reqType: 2 // 1-首页 2-分类页
      }
      this.bannerData = []
      service.queryPageModuleTabResourceImg(params).then((res) => {
        if (res.errorCode === 0) {
          const bannerData = res.data || []
          if (bannerData.length > 0) {
            this.bannerData = bannerData
            this.initSwiper()
          }
        } 
        this.SETBANNERREQ(this.bannerData.length > 0 ? 0 : 3)
      }).catch(() => {
        this.SETBANNERREQ(3)
      })
    },
    initSwiper() {
      this.$nextTick(() => {
        if (this.newBannerSwiper && this.newBannerSwiper.destroy) {
          this.newBannerSwiper.destroy()
        }
        this.newBannerSwiper = new Swiper('#new-banner', {
          autoplay: 4000,
          direction: 'horizontal',
          loop: true,
          autoplayDisableOnInteraction: false, // 用户操作swiper之后自动切换不会停止，每次都会重新启动
          pagination: '.swiper-pagination',
          onInit: (swiper) => {
            // 小于2张图片时 不 播放swiper
            if (this.bannerData && this.bannerData.length <= 1) {
              swiper.lockSwipes() // 锁住状态
            } else {
              swiper.unlockSwipes() // 一般状态
            }
          },
          onClick: (swiper) => {
            const index = swiper.realIndex
            if (this.bannerData[index].type == 1) {
              // 专题才销毁
              swiper.destroy(false) // 移除所有slide监听事件，所以拖动和click事件失效了
            }
            this.bannerClick(this.bannerData[index], index)
          }
        })
      })
    },
    // 离开曝光
    moduleLeave() {
      // 【新品+类目】banner点击
      // console.log(createTrackContentIdList(this.bannerData))
      window.thinkingReport.track('exposure', {
        page_id: 10294,
        point_id: 28615,
        content_type: '离开曝光',
        content_id: createTrackContentIdList(this.bannerData),
        tab_name: this.parentLevelName,
        module_name: 'banner'
      })
    },
    /**
     * banner图点击
     */
    bannerClick(obj, index) {
      // 【新品+类目】banner点击
      window.thinkingReport.track('click_list', {
        page_id: 10294,
        point_id: 28614,
        tab_name: this.parentLevelName,
        index: index + 1,
        module_name: 'banner',
        ...createTrackObj(obj.jumpType, obj.jumpValue)
      })
      obj.appCont = this.appCont
      obj.shopId = this.shopId
      if (isWxProgram) jumpHandle(obj, 7)
      else if (isApp) jumpHandle(obj, 1)
      else jumpHandle(obj, 0)
    }
  }
}
</script>
<style lang="less" scoped>
@import '../../../../../assets/css/swiper.min.css';
  .top-moudle{
    position: relative;
    background-size: 100% auto;
    .search-bar{
      left: 0;
      z-index: 10;
      width: 100%;
      height: 0.88rem;
      display: flex;
      align-items: center;
      .icon-titlebar_search_icon {
        font-size: 0.52rem;
        vertical-align: middle;
        margin-left: 5px;
        color: #EE2532;
      }
      .scroll-box {
        flex: 1;
        vertical-align: middle;
        font-size: 12px;
        color: rgb(255,255,255);
        height: 0.6rem;
        overflow: hidden;
        text-align: center;
        .scroll-list{
          &.animate{
            transition: all 0.3s;
            margin-top: -0.6rem;
          }
          li {
            opacity: 0.9;
            font-family: PingFangSC-Regular;
            font-size: 0.24rem;
            color: #999999;
            width: 100%;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            text-align: left;
            line-height: 0;
            padding: 0.3rem 0;
          }
        }
      }
      .cart-entry{
        overflow: hidden;
        display: flex;
        .right-btn{
          padding-top:0.04rem;
          float: left;
          margin-left: 0.28rem;
          text-align: center;
          line-height: 0.25rem;
          color: #666666;
          font-size: 0.18rem;
          white-space:nowrap;
        }
        img{
         width: 0.36rem;
         margin: 0 auto;
        &.w{
          display: none;
        }
        }
      }
    }
    .normal-banner {
      // width: 5.5rem;
      height: 2.225rem;
    }
    .new-good-banner {
      // width: 5.5rem;
      height: 3.09rem;
    }
    .swiper-container{
      border-radius: 0.08rem;
      /deep/.swiper-pagination {
        text-align: right;
        bottom: .04rem;
        padding-right: .12rem;
      }
      /deep/.swiper-pagination-bullet {
        opacity: 0.8;
        width: 0.08rem;
        height: 0.06rem;
        background: #FFFFFF;
        border-radius: 0.03rem;
        display: inline-block;
        margin: 0 2px;
        &.swiper-pagination-bullet-active {
          opacity: 1;
          width: .24rem
        }
      }
      .banner-pic-wrapper{
        width: 5.5rem;
        background: #f8f8f8;
        overflow: hidden;
        height: 100%;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .presaleTip{ position: absolute; right:.24rem; top:1.18rem; z-index: 99; }
  .backgroundType2  .search-bar {
    .cart-entry{
        overflow: hidden;
        .right-btn{
          color: #ffffff;
        }
        img{
          display: none;
          &.w{
            display: block;
          }
        }
    }
    .icon-titlebar_search_icon {
      color:#828282;
    }
  }
</style>
